import { formatLocation, getClinicStatus, getClinicType } from "./clinicFields";

export const TEXT_FILTERS = [
  { key: "title", label: "ClinicName", getValue: (clinic) => clinic.title },
  { key: "shortName", label: "ShortName", getValue: (clinic) => clinic.shortName },
  { key: "location", label: "Location", getValue: formatLocation },
  { key: "email", label: "Email", getValue: (clinic) => clinic.email },
  { key: "phoneNumber", label: "PhoneNumber", getValue: (clinic) => clinic.phoneNumber },
];

const SELECT_FILTER_KEYS = ["tier", "clinicType", "status"];
export const FILTER_KEYS = [...TEXT_FILTERS.map(({ key }) => key), ...SELECT_FILTER_KEYS];

function normalize(value) {
  return String(value ?? "").trim().toLowerCase();
}

function digitsOnly(value) {
  return String(value ?? "").replace(/\D/g, "");
}

/**
 * Case-insensitive "contains" match. Phone numbers also match on digits alone,
 * so "01 6221" finds "01/6221 263".
 */
function matchesText(value, needle, compareDigits) {
  if (normalize(value).includes(needle)) return true;
  const needleDigits = digitsOnly(needle);
  return compareDigits && needleDigits !== "" && digitsOnly(value).includes(needleDigits);
}

function matchesSearch(clinic, search) {
  const needle = normalize(search);
  if (!needle) return true;
  return TEXT_FILTERS.some(({ getValue }) =>
    normalize(getValue(clinic)).includes(needle),
  );
}

function matchesFilters(clinic, filters) {
  const textMatches = TEXT_FILTERS.every(({ key, getValue }) => {
    const needle = normalize(filters[key]);
    return !needle || matchesText(getValue(clinic), needle, key === "phoneNumber");
  });
  const tierMatches = !filters.tier || String(clinic.tierId) === filters.tier;
  const typeMatches = !filters.clinicType || getClinicType(clinic) === filters.clinicType;
  const statusMatches = !filters.status || getClinicStatus(clinic) === filters.status;
  return textMatches && tierMatches && typeMatches && statusMatches;
}

export function filterClinics(clinics, search, filters) {
  return clinics.filter(
    (clinic) => matchesSearch(clinic, search) && matchesFilters(clinic, filters),
  );
}

export function countActiveFilters(filters) {
  return FILTER_KEYS.filter((key) => normalize(filters[key])).length;
}
